<template>
    
    <template v-for="(campi, nome) in label">
        <h1 v-if="nome != '_config'" class=" text-2xl font-bold my-3">
            {{ renderTitolo(nome) }}
        </h1>
        <FormInput :dati='info'
                     :formlabel="campi"
                     :stilestruttura="style"
                     :idform="idform"
                     :action="action"
                     :recaptcha="recaptcha"
                     :ref="'input_' + nome"
                     @checkboxChanged="updateSelect">
          </FormInput>
    </template>
  
      <div class="text-right">
          <a v-if="cancel !== ''" type="button" class="p-button p-component p-button-secondary"
               :href="cancel">{{ bottoneannulla }}</a>
          <button @click="checkCampi" class="p-button p-component p-button-success">
              <span class="p-button-label">{{ bottonesalva }}</span>
          </button>
      </div>
      <ConfirmDialog></ConfirmDialog>

  </template>
  
  <script>
  
  import  ConfirmDialog  from 'primevue/confirmdialog';
import FormInput from './FormInput.vue';
  
  export default {
    name: "CompilaOnoffboardingForm",
    components: {
      FormInput,
      ConfirmDialog
    },
    props: [
      'dati',
      'struttura',
      'azione',
      'annulla',
      'stilestruttura',
      'id',
      'tipologia',
      'recaptcha',
      'bottonesalva',
      'bottonesalvacontinua',
      'bottoneannulla'
    ],
    data() {
      return {
        cancel: this.annulla,
        action: this.azione,
        info: JSON.parse(this.dati),
        label: JSON.parse(this.struttura),
        style: this.stilestruttura,
        errors: {},
        imginput: false,
        idform: this.id,
      };
    },
    beforeMount() {
      if (typeof this.id == "undefined") {
        this.idform = 'maschera';
      } else {
        this.idform = this.id;
      }
  
    },
    mounted() {
        console.log(this.label)
      document.addEventListener('formChanged', function(e){
        this.label = e.detail.newStruttura;
      });
  
    },
    methods: {
        renderTitolo(nome){
            return nome
                .split('_')
                .map((p)=> p.charAt(0).toUpperCase() + p.slice(1))
                .join(' ')
        },
        checkCampi: async function() {
            
            const props = {...this.$refs['input__config'][0]}['_']
            const data = {...props.data}
            const info_estratte = {...data.info}
            console.log(info_estratte)
            let errors = false;
            for (const name in this.label) {
                if (Object.prototype.hasOwnProperty.call(this.label, name)) {
                    const form = this.label[name];
                    
                }
                if( name != '_config') {
                    const hasErrors = await this.$refs['input_' + name][0].checkForm(3);
                    console.log(name + ":" + hasErrors)
                    if(hasErrors) {
                        errors = true;
                    }
                }
                
                
            }
            // se non ho riscontrato errori posso aprire la modale che chiede necessità di conferma o meno
            if(!errors) {

              // se la tipologia è onboarding allora chiedo conferma
              if(this.tipologia == 'onboarding') {
                this.$confirm.require({
                    message: this.$root.trans.onoffboarding_serve_conferma_message,
                    header: this.$root.trans.onoffboarding_serve_conferma_title,
                    rejectProps:{
                        label: this.$root.trans.reject
                    },
                    acceptProps:{
                        label: this.$root.trans.accept
                    },
                    accept: ()=>{
                        // salvo il modulo e nei dati metto approvazione = 0
                        // restituisco l'id del modulodati e faccio redirect alla pagina per invio mail
                        this.info = {...this.info, approvazione: 0}
                        this.sendForm();
                        
                    },
                    reject: ()=>{
                        // salvo il modulo e nei dati metto approvazione = 1
                        // apro contestualmente anche il ticket
                        this.info = {...this.info, approvazione: 1}
                        this.sendForm();
                    }
                })
              }else{
                // se invece è di tipo offboarding allora non chiedo conferma
                // apro invece direttamente il ticket
                this.info = {...this.info, approvazione: 1}
                this.sendForm();
                        
              }
                
            }
        },
        sendForm: function(){
          axios.post('/moduli/compila/salva', this.info).then((response)=>{
            if (response.data.success) {
              this.$toast.add({
                severity: 'success',
                summary: this.$root.trans.success_form,
                detail: this.$root.trans.salvataggio_success,
                life: 3000
              });
              if (response.data.params) {
                window.location.href = route(response.data.redirect, response.data.params);
              } else {
                window.location.href = route(response.data.redirect);
              }
            }else {
              if (response.data.message != null) {
                this.$toast.add({
                  severity: 'errors',
                  summary: this.$root.trans.errors_form,
                  detail: this.$root.trans[response.data.message],
                  life: 5000
                });
              } else {
                this.$toast.add({
                  severity: 'errors',
                  summary: this.$root.trans.errors_form,
                  detail: this.$root.trans.salvataggio_errato,
                  life: 3000
                });
              }
            }
          })
        },

        updateSelect:function(e,k,info, label){
            if(k=='filtro'){
                const filtri = [...info.filtro]
                axios.post('/moduli/utenti/filtra', {
                    filtri: filtri
                })
                .then((response) => {
                    const destinatari_filtrati = response.data
                    this.label['destinatario_form']['destinatario'][3] = destinatari_filtrati
                })
            }
        }
    }
  }
  </script>
  
  <style scoped>
  
  </style>